// dependancies
import React from "react";
import PropTypes from "prop-types";

// components
import Label from "../label/Label";
import InputGroup from "../input_group/InputGroup";

// styled components
import SelectStyled from "./Select.styled";

const Select = props => {
    const {
        /**
         * `id` sets the id of the select, is a string and isRequired
         */
        id,
        /**
         * `name` sets the name of the select, is a string and isRequired
         */
        name,
        /**
         * `required` sets the requirement of the select and is a boolean
         */
        required,
        /**
         * `error` boolean to set if the select has an error
         */
        error,
        /**
         * `labelText` sets the label text, is a string and isRequired
         */
        labelText,
        /**
         * `change` onChange function
         */
        change,
        /**
         * `focus` onFocus function
         */
        focus,
        /**
         * `focused` boolean to check if select is focused
         */
        focused,
        /**
         * `options` array that needs to be passed as props. the array needs to include ia and value and isRequired
         */
        options,
        /**
         * `defaultValue` defaultValue for the select and isRequired
         */
        defaultValue
    } = props;
    return (
        <SelectStyled error={error} focused={focused}>
            <InputGroup>
                <Label htmlFor={name} text={labelText} />
                <select id={id} name={name} required={required} onChange={change} onFocus={focus} defaultValue={defaultValue}>
                    <option disabled value={defaultValue}>
                        {defaultValue}
                    </option>
                    {/* Loop the options passed in via props */}
                    {options &&
                        options.map(item => {
                            return (
                                <option key={item.id} data-value={item.available} value={item.value}>
                                    {item.value}
                                </option>
                            );
                        })}
                </select>
            </InputGroup>
        </SelectStyled>
    );
};

// props validation
Select.propTypes = {
    id: PropTypes.string.isRequired,
    labelText: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired, // used to populate the select options
    defaultValue: PropTypes.string.isRequired, // used to set the defaultValue
    change: PropTypes.func,
    focus: PropTypes.func,
    focused: PropTypes.bool,
    required: PropTypes.bool,
    error: PropTypes.bool
};

export default Select;
